<template>
  <component :is="promotionComponent" :shop="shop" @next="$emit('next', $event)" />
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    PrepaidVoucherBundle: () => import('@/components/promotion/PrepaidVoucherBundle'),
  },

  props: {
    /* Shop as object */
    shop: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      promotionComponent: null,
    };
  },

  computed: {
    ...mapState({
      form: (state) => state.customer.form,
    }),

    ...mapGetters({
      country: 'getCountry',
      showShopPromotion: 'getShowShopPromotion',
    }),
  },

  created() {
    // prepaid voucher bundle promotion
    if (
      // don't show if a payment is required
      !this.form?.paymentRequired &&
      // show only if show shop promotion is enabled in sites config
      this.showShopPromotion &&
      // show only for certain redeem values
      ((this.form?.redeemValue === 1500 && this.shopHasVoucherValue(1000, 'EUR') && this.shopHasVoucherValue(1500, 'EUR')) ||
        (this.form?.redeemValue === 2500 && this.shopHasVoucherValue(2000, 'EUR') && this.shopHasVoucherValue(2500, 'EUR')))
    ) {
      this.promotionComponent = 'PrepaidVoucherBundle';
    } else {
      this.$emit('next');
    }
  },

  methods: {
    shopHasVoucherValue(value, currency) {
      // eslint-disable-next-line arrow-body-style
      return typeof this.shop.voucherValues.find((shopVoucherValue) => {
        return shopVoucherValue.valueInCent === value && shopVoucherValue.currency === currency;
      }) !== 'undefined';
    },
  },
};
</script>
